const fastDeliveryDisplayTypes = {
  KEY_VALUE: "key_value",
  TEXT: "text",
};

export { fastDeliveryDisplayTypes };
